<template>
  <div>
    <div class="order-type-enter-time" v-if="slotMode && !isMobile()">
      <div class="popup-container" :style="dateFieldStyles">
        <div class="top-inputs">
          <div class="half-field">
            <div class="input-icon-container">
              <img
                src="@/assets/icons/icon-calendar.svg"
                @click="$refs.programaticOpen.showCalendar()"
              />
            </div>
            <date-picker
              name="deliveryDT"
              v-if="isDelivery"
              @closed="setTimes(deliveryDate)"
              v-model="deliveryDate"
              :disabledDates="deliveryDisabledDates"
              ref="programaticOpen"
            ></date-picker>
            <date-picker
              name="deliveryDT"
              v-else
              @closed="setTimes(pickupDate)"
              v-model="pickupDate"
              :disabledDates="pickupDisabledDates"
              ref="programaticOpen"
            ></date-picker>
          </div>
        </div>
      </div>
      <div
        v-if="!isRolldStore() && isDelivery && dtimes.length > 0"
        :class="{
          'timeslots-container': !isMobile(),
          'timeslots-container-mobile': isMobile(),
        }"
      >
        <div v-if="asapSlot" class="timeslot-container asap">
          <div
            class="timeslot"
            :style="
              selectedDeliveryTime == asapSlot.time ? selectedSlotStyles : {}
            "
            @click="
              selectedDeliveryTime = asapSlot.time;
              selectedDeliveryTimeChange();
            "
          >
            ASAP
            <br />
            {{ asapSlot.format.toUpperCase() }}
          </div>
        </div>
        <div
          class="timeslot-container"
          v-for="slot in otherSlots"
          :key="slot.time.tc"
          @click="
            selectedDeliveryTime = slot.time;
            selectedDeliveryTimeChange();
          "
        >
          <div
            class="timeslot"
            :style="selectedDeliveryTime == slot.time ? selectedSlotStyles : {}"
          >
            {{ slot.format.toUpperCase() }}
          </div>
        </div>
      </div>
    </div>
    <div class="calendar-overlay" v-if="showOverlay && isMobile()">
      <div class="col-6" style="padding: 17px 12px 13px">
        <span class="material-icons md-36">
          <img
            src="@/assets/back-arrow.png"
            class="icon-back-arrow"
            @click="closeOverlay"
          />
        </span>
      </div>
      <div class="overlay-title rolld-primary-color">
        Choose {{ isDelivery ? "Delivery" : "Pickup" }} Date
      </div>
      <date-picker
        name="deliveryDTP"
        v-if="isDelivery"
        @selected="setTimes"
        v-model="deliveryDate"
        :disabledDates="deliveryDisabledDates"
        :inline="true"
        calendar-class="inline-calendar"
      ></date-picker>
      <date-picker
        name="pickupDTP"
        v-else
        @selected="setTimes"
        v-model="pickupDate"
        :disabledDates="pickupDisabledDates"
        :inline="true"
        calendar-class="inline-calendar"
      ></date-picker>
      <div class="full-extras-footer d-flex justify-content-center">
        <button
          @click="closeOverlay"
          :style="mobileStyles.btn"
          class="btn btn-primary btn-confirm-overlay"
        >
          {{ $t("message.confirmDate") }}
        </button>
      </div>
    </div>
    <div
      class="deliver-date-component"
      v-if="isMobile()"
      :style="dateFieldStyles"
    >
      <div v-show="false" class="arrow-left" @click="addDaysToDeliveryDate(-1)">
        <span class="material-icons md-36">
          <img src="@/assets/back-arrow.png" class="icon-back-arrow" />
        </span>
      </div>
      <div
        class="date-container"
        :style="showNewUiIos && 'margin-top : 10%'"
        @click="openOverlay"
      >
        <span style="font-size: 25px" class="day-of-week">{{
          selectedDayOfWeek
        }}</span>
        <br />
        <span style="font-size: 35px" class="full-date">{{
          selectedDateString
        }}</span>
      </div>
      <div v-show="false" class="arrow-right" @click="addDaysToDeliveryDate(1)">
        <span class="material-icons md-36">
          <img
            src="@/assets/icons/icon-arrow-right.svg"
            class="icon-back-arrow"
          />
        </span>
      </div>
    </div>
    <div class="order-type-enter-time">
      <div v-if="isDelivery && isRolldStore()" class="select-container">
        <label
          for="date-select-delivery"
          style="display: block; margin: 14px 0 12px; font-size: 12px"
        >
          {{ fieldLabel }}

          <span style="color: red">&nbsp;*</span>
        </label>

        <vselect
          name="ate-select-delivery"
          class="lg"
          :options="dtimes"
          :searchable="false"
          :clearable="false"
          v-model="selectedDeliveryTime"
          label="format"
          :reduce="(slot) => slot.to"
          @input="selectedDeliveryTimeChange"
        >
        </vselect>
      </div>
      <div v-if="!isDelivery" class="select-container">
        <label
          for="date-select-pickup"
          style="
            display: block;
            margin: 14px 0 12px;
            font-size: 25px;
            color: black;
          "
        >
          {{ fieldLabel }}
          <span style="color: red">&nbsp;*</span>
        </label>
        <vselect
          name="date-select-pickup"
          class="lg"
          :options="pickupTimes"
          :searchable="false"
          :clearable="false"
          v-model="selectedDeliveryTime"
          label="format"
          :reduce="(slot) => slot.time"
          @input="selectedDeliveryTimeChange"
        >
        </vselect>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vuejs-datepicker";
import {
  initPickupDeliveryTimes,
  getCurrentDate,
  getNexOpenDate,
  availablePickupDeliveryDates,
  getServerTime,
} from "../../../api/helpers/datetimeHelper";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { DateTime } from "luxon";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
} from "./../../../constants/strings";
import vselect from "vue-select";
export default {
  name: "EnterDeliveryTime",
  components: {
    DatePicker,
    vselect,
  },
  data() {
    return {
      selectedSlotIndex: 0,
      deliveryDate: new Date(),
      pickupDate: new Date(),
      deliveryTime: null,
      selectedDeliveryTime: null,
      deliveryDisabledDates: {},
      pickupDisabledDates: {},
      dtimes: [],
      pickupTimes: [],
      showOverlay: false,
    };
  },
  mounted() {
    this.setPickupDeliveryDates();
    this.deliveryDate = this.pickupDate = getServerTime();
  },
  computed: {
    ...mapGetters([
      "desktopStyles",
      "selectedCompany",
      "getDeliveryDuration",
      "getOrderPreparationTime",
      "isDeliveryTimeSlotsEnable",
      "deliveryTimeSlots",
      "getSelectedMenuType",
      "getIsDoorDashDelivery",
      "viewConfig",
      "mobileStyles",
      "selectedTS",
    ]),
    slotMode() {
      return (
        this.isDelivery ||
        this.getSelectedMenuType == CONSTANT_ORDER_TYPE_PICKUP
      );
    },
    dateFieldStyles() {
      const isPickup = this.getSelectedMenuType == CONSTANT_ORDER_TYPE_PICKUP;
      const { EnablePreoderForDelivery, EnablePreoderForPickup } =
        this.selectedCompany;

      const hideDateField =
        (this.isDelivery && !EnablePreoderForDelivery) ||
        (isPickup && !EnablePreoderForPickup);

      return hideDateField ? { display: "none" } : null;
    },
    isDelivery() {
      return this.getSelectedMenuType == CONSTANT_ORDER_TYPE_DELIVERY;
    },
    asapSlot() {
      var asap = this.dtimes.find((p) => p.format.indexOf("ASAP") >= 0);
      if (asap) {
        asap.format = asap.format.split("(")[1].split(")")[0];
      }
      return asap;
    },
    otherSlots() {
      if (this.asapSlot) {
        const lastIndex = /*this.dtimes.length > 9 ? 9 :*/ this.dtimes.length;
        return this.dtimes.slice(1, lastIndex);
      } else {
        return this.dtimes;
      }
    },
    selectedSlotStyles() {
      const styles = this.desktopStyles.btn;
      return {
        background: this.isRolldStore() ? "#085748" : styles.background,
        color: styles.color,
        borderColor: this.isRolldStore() ? "#085748" : styles.background,
      };
    },
    fieldLabel() {
      return this.isDelivery
        ? this.$t("message.deliveryTime")
        : this.$t("message.pickupTime");
    },
    selectedDayOfWeek() {
      var scheduledDate = this.isDelivery
        ? this.deliveryDate || null
        : this.pickupDate;
      return scheduledDate === null
        ? "..."
        : scheduledDate.toLocaleString("en-us", { weekday: "long" });
    },
    selectedDateString() {
      const deliveryDate = this.isDelivery
        ? this.deliveryDate
        : this.pickupDate;
      if (!deliveryDate) {
        return "...";
      } else {
        const monthNames = new Array(
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        );

        var date = deliveryDate.getDate();
        var month = deliveryDate.getMonth();
        var year = deliveryDate.getFullYear();

        return monthNames[month].concat(" ", date, ", ", year);
      }
    },
    isIos() {
      return !!navigator.platform.match(/iPhone|iPod|iPad/);
    },

    showNewUi() {
      return this.viewConfig.IsNewUi;
    },

    // new UI on ios
    showNewUiIos() {
      return this.showNewUi && this.isIos;
    },
  },
  methods: {
    ...mapActions(["applyDeliveryAddress"]),
    ...mapMutations(["setScheduledDeliveryTime", "setSurchargeTime"]),
    selectSlot(index) {
      this.selectedSlotIndex = index;
    },
    setPickupDeliveryDates() {
      let date = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      const pickupPreorderEnabled =
        this.selectedCompany.EnablePreoderForPickup || false;
      const deliveryPreorderEnabled =
        this.selectedCompany.EnablePreoderForDelivery || false;
      let deliveryAvailableDates = availablePickupDeliveryDates(
        this.selectedTS(),
        this.selectedCompany.OrderPreparationDeliveryBuffer,
        this.selectedCompany.BlackoutDates,
        false,
        this.getIsDoorDashDelivery,
        this.getOrderPreparationTime,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation ||
          this.selectedCompany.EnablePreoderForDelivery,
        date,
        this.selectedCompany.NumberOfDaysInAdvanceForDelivery,
        deliveryPreorderEnabled,
        this.selectedCompany.PreOrderCutOffDays && deliveryPreorderEnabled
          ? this.selectedCompany.PreOrderCutOffDays || 0
          : 0,
        deliveryPreorderEnabled
          ? this.selectedCompany.PreOrderCutOffTime
          : "00:00",
        this.deliveryTimeSlots,
        this.isDeliveryTimeSlotsEnable
      );
      let pickupAvailableDates = availablePickupDeliveryDates(
        this.selectedTS(),
        this.selectedCompany.OrderPreparationDeliveryBuffer,
        this.selectedCompany.BlackoutDates,
        true,
        false,
        this.getOrderPreparationTime,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation ||
          this.selectedCompany.EnablePreoderForPickup,
        date,
        this.selectedCompany.NumberOfDaysInAdvanceForPickup,
        pickupPreorderEnabled,
        this.selectedCompany.PreOrderCutOffDays && pickupPreorderEnabled
          ? this.selectedCompany.PreOrderCutOffDays || 0
          : 0,
        pickupPreorderEnabled
          ? this.selectedCompany.PreOrderCutOffTime
          : "00:00"
      );
      this.deliveryDisabledDates = deliveryAvailableDates[0];
      let deliveryStartDate = deliveryAvailableDates[1];

      this.pickupDisabledDates = pickupAvailableDates[0];
      let pickupStartDate = pickupAvailableDates[1];

      this.deliveryDate = deliveryStartDate
        ? deliveryStartDate.toJSDate()
        : null;

      this.pickupDate = this.startdate = pickupStartDate
        ? pickupStartDate.toJSDate()
        : null;

      this.setDeliveryTimes(this.deliveryDate);
      this.setPickupTimes(this.pickupDate);
    },
    isPreOrder() {
      if (!this.deliveryDate) {
        return false;
      }
      var date = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      var deliveryDate = DateTime.fromISO(
        DateTime.fromJSDate(this.deliveryDate).toISODate()
      );
      if (date.day != deliveryDate.day) {
        return true;
      }
      return false;
    },
    selectedDeliveryTimeChange() {
      if (this.isDelivery) {
        this.setScheduledDeliveryTime(
          new Date(this.selectedDeliveryTime).toISOString()
        );
      }
      this.$emit(
        "set-scheduled-time",
        new Date(this.selectedDeliveryTime).toISOString()
      );
      this.setSurchargeTime(this.selectedDeliveryTime.toISODate());
    },

    setTimes(date) {
      if (this.isDelivery) {
        this.setDeliveryTimes(date, true);
      } else {
        this.setPickupTimes(date, true);
      }
    },
    setDeliveryTimes(date, recursive = false) {
      var dpDate = new Date(DateTime.local().ts);
      if (this.deliveryDate != date) {
        this.deliveryDate = date;
      }
      dpDate = this.deliveryDate;
      this.dtimes = initPickupDeliveryTimes(
        this.selectedTS(),
        this.selectedCompany.OrderPreparationDeliveryBuffer,
        this.selectedCompany.BlackoutDates,
        false,
        this.getIsDoorDashDelivery,
        this.selectedCompany.OperatingHours,
        this.getOrderPreparationTime,
        dpDate,
        getCurrentDate(this.selectedCompany.TimezoneIanaFormat),
        this.getDeliveryDuration,
        false,
        this.selectedCompany.DeliveryTimeInterval,
        this.deliveryTimeSlots,
        this.isDeliveryTimeSlotsEnable,
        this.isPreOrder ? this.selectedCompany.PreOrderCutOffTime : null
      );
      if (this.dtimes.length > 0) {
        if (this.isDelivery) {
          this.selectedDeliveryTime = this.dtimes[0].time;
          this.selectedDeliveryTimeChange();
        }
      } else if (!recursive && this.selectedCompany.EnablePreoderForDelivery) {
        var currentDate = getCurrentDate(
          this.selectedCompany.TimezoneIanaFormat
        );
        var startDate = currentDate;
        startDate = getNexOpenDate(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          currentDate.plus({
            days: 1,
          }),
          false,
          this.deliveryTimeSlots,
          this.isDeliveryTimeSlotsEnable
        );
        this.deliveryDate = startDate ? startDate.toJSDate() : null;
        this.setDeliveryTimes(this.deliveryDate, true);
        return;
      } else {
        this.selectedDeliveryTime = null;
      }

      if (this.dtimes.length == 0) {
        this.setScheduledDeliveryTime(null);
      } else {
        this.setScheduledDeliveryTime(
          new Date(this.selectedDeliveryTime).toISOString()
        );
      }
    },
    setPickupTimes(date, recursive = false) {
      var dpDate = null;
      if (this.pickupDate != date) {
        this.pickupDate = date;
      }
      dpDate = this.pickupDate;
      this.pickupTimes = initPickupDeliveryTimes(
        this.selectedTS(),
        this.selectedCompany.OrderPreparationDeliveryBuffer,
        this.selectedCompany.BlackoutDates,
        true,
        false,
        this.selectedCompany.OperatingHours,
        this.getOrderPreparationTime,
        dpDate,
        getCurrentDate(this.selectedCompany.TimezoneIanaFormat),
        0,
        false,
        this.selectedCompany.PickupTimeInterval
      );
      if (this.pickupTimes.length > 0) {
        if (this.pickupTimes[0] && !this.isDelivery) {
          this.selectedDeliveryTime = this.pickupTimes[0].time;
          this.selectedDeliveryTimeChange();
        }
      } else if (!recursive && this.selectedCompany.EnablePreoderForPickup) {
        var currentDate = getCurrentDate(
          this.selectedCompany.TimezoneIanaFormat
        );
        var startDate = currentDate;
        startDate = getNexOpenDate(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          currentDate.plus({
            days: 1,
          }),
          true,
          null,
          false
        );
        this.pickupDate = startDate ? startDate.toJSDate() : null;
        if (this.pickupDate) this.setPickupTimes(this.pickupDate, true);
        return;
      }
    },
    openOverlay() {
      this.showOverlay = true;
    },
    closeOverlay() {
      this.showOverlay = false;
    },
  },
};
</script>
